import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    divisionId: string;
};

export const schemaUserResolver_GetAdvisersByDivision = z.array(
    UsersTableDefinitionZod.pick({
        deactivated: true,
        firstName: true,
        id: true,
        lastName: true,
        role: true,
    }),
);

export type SchemaUserResolver_GetAdvisersByDivision = z.infer<typeof schemaUserResolver_GetAdvisersByDivision>;

export type UserResolver_GetAdvisersByDivision = Resolver<Arguments, SchemaUserResolver_GetAdvisersByDivision>;
